export const initial = {
  saving: false,
  visible: false,
  participants: []
};

export const participants = (state = [], action = {}) => {
  switch (action.type) {
    case 'RANKING_PARTICIPANTS_ADD':
      return state.some(({ _id }) => action.payload._id === _id)
        ? state
        : [...state, action.payload];
    case 'RANKING_PARTICIPANTS_REMOVE':
      return state.filter(({ _id }) => _id !== action.meta._id);
    default:
      return state;
  }
};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'RANKING_PARTICIPANTS_SAVING':
      return { ...state, saving: action.payload };
    case 'RANKING_PARTICIPANTS_CLEAR':
      return initial;
    case 'RANKING_PARTICIPANTS_VISIBLE':
      return { ...state, visible: action.payload };
    case 'RANKING_PARTICIPANTS_ADD':
    case 'RANKING_PARTICIPANTS_REMOVE':
      return {
        ...state,
        participants: participants(state.participants, action)
      };
    default:
      return state;
  }
};
